import { cfgCdnBanners, stateFeatureSet, wantAtLeastReleaseStage } from '@infinitro/config';
import { get } from 'svelte/store';
const CDN_BANNER_BASE = cfgCdnBanners();
const featureSet = get(stateFeatureSet);
export const buildBannerPath = (banner, mobile, variant, loc) => {
    // const specialFor = banner.specialFor ? `_${banner.specialFor}` : '';
    // const suffix = mobile ? `${v}${specialFor}-mobile` : `${v}${specialFor}`;
    const langPath = loc ? `${loc}/` : '';
    const v = variant === 'default' ? '' : `_${variant}`;
    const dimensions = mobile ? banner.mobileBannerSize : banner.desktopBannerSize;
    const ext = banner.ext ?? 'png';
    return `${CDN_BANNER_BASE}${banner.id}/${langPath}${banner.id}${v}_${dimensions}.${ext}`;
};
export const getBannerFallbackPath = (banner, mobile, variant) => {
    return buildBannerPath(banner, mobile, variant);
};
export const getBannerId = (url) => url
    .split('/')
    .pop()
    .replace(/(_.*)?-?mobile\.png|\.png/i, '');
export const filter = (data) => data.filter((b) => b.show && (!b.rel || b.rel === featureSet) && (!b.stage || wantAtLeastReleaseStage(b.stage)));
